export default __webpack_public_path__ + "static/media/companyInfo_grey.e0020f16.svg";